import { AUDIO_FILE_PATH } from '../TabManager/constants';

const playSound = (): void => {
    new Audio(AUDIO_FILE_PATH).play();
};

export const NotificationSound = {
    playSound,
};
